import React, { useState, useEffect } from 'react';
import './PedidosList.css';
import Sidebar from '../../components/Sidebar/Sidebar';
import Topbar from '../../components/Topbar/Topbar';
import {
  LayoutDashboard, FileText, Users, ShoppingBag, BarChart2,
  User, Mail, Calendar, Eye, ChevronLeft, ChevronRight, Filter, Search, ChevronDown, ChevronUp, Plus, MoreVertical, Edit, Trash2, X
} from 'lucide-react';
import { API_URL } from '../../api';

const statusColors = {
  'pendente': { bg: '#fef9c3', color: '#b45309' },
  'processando': { bg: '#dbeafe', color: '#2563eb' },
  'cancelado': { bg: '#fee2e2', color: '#e11d48' },
  'enviado': { bg: '#ede9fe', color: '#7c3aed' },
};

function formatDate(dataStr, horaStr = '') {
  if (!dataStr) return '';
  
  const data = new Date(dataStr);
  const dataFormatada = data.toLocaleDateString('pt-BR');
  
  if (horaStr) {
    return `${dataFormatada}, ${horaStr}`;
  }
  
  return dataFormatada;
}

function PedidosList() {
  const [menuAberto, setMenuAberto] = useState(false);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [filtrosAbertos, setFiltrosAbertos] = useState(true);
  const [filtros, setFiltros] = useState({
    nomeCliente: '',
    numeroPedido: '',
    cnpjCliente: '',
    dataInicial: '',
    dataFinal: '',
    status: '',
  });
  const [filtrosAplicados, setFiltrosAplicados] = useState({});
  const [pedidos, setPedidos] = useState([]);
  const [totalItens, setTotalItens] = useState(0);
  const [totalPaginas, setTotalPaginas] = useState(1);
  const [carregando, setCarregando] = useState(false);
  const [menuAcoesAberto, setMenuAcoesAberto] = useState(null);
  const [pedidoDetalhes, setPedidoDetalhes] = useState(null);

  useEffect(() => {
    async function fetchPedidos() {
      setCarregando(true);
      try {
        let url = `${API_URL}/pedidos?page=${paginaAtual}`;
        // Adicionar filtros aplicados na query string
        const params = [];
        if (filtrosAplicados.nomeCliente) params.push(`nome_cliente=${encodeURIComponent(filtrosAplicados.nomeCliente)}`);
        if (filtrosAplicados.numeroPedido) params.push(`numero_pedido=${encodeURIComponent(filtrosAplicados.numeroPedido)}`);
        if (filtrosAplicados.cnpjCliente) params.push(`cnpj_cliente=${encodeURIComponent(filtrosAplicados.cnpjCliente)}`);
        if (filtrosAplicados.dataInicial) params.push(`data_inicial=${encodeURIComponent(filtrosAplicados.dataInicial)}`);
        if (filtrosAplicados.dataFinal) params.push(`data_final=${encodeURIComponent(filtrosAplicados.dataFinal)}`);
        if (filtrosAplicados.status) params.push(`status=${encodeURIComponent(filtrosAplicados.status)}`);
        if (params.length > 0) {
          url += '&' + params.join('&');
        }
        const token = localStorage.getItem('token');
        const response = await fetch(url, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        const data = await response.json();
        setPedidos(data.data || []);
        setTotalItens(data.total || 0);
        setTotalPaginas(data.last_page || 1);
      } catch (e) {
        setPedidos([]);
        setTotalItens(0);
        setTotalPaginas(1);
      } finally {
        setCarregando(false);
      }
    }
    fetchPedidos();
  }, [paginaAtual, filtrosAplicados]);

  const handleChangeFiltro = (e) => {
    const { name, value } = e.target;
    setFiltros((prev) => ({ ...prev, [name]: value }));
  };

  const handlePesquisar = (e) => {
    e.preventDefault();
    setFiltrosAplicados({ ...filtros });
    setPaginaAtual(1);
  };

  const handleLimpar = () => {
    const filtrosLimpos = {
      nomeCliente: '',
      numeroPedido: '',
      cnpjCliente: '',
      dataInicial: '',
      dataFinal: '',
      status: '',
    };
    setFiltros(filtrosLimpos);
    setFiltrosAplicados(filtrosLimpos);
    setPaginaAtual(1);
  };

  const mudarPagina = (novaPagina) => {
    if (novaPagina >= 1 && novaPagina <= totalPaginas) {
      setPaginaAtual(novaPagina);
    }
  };

  // Gerar array de páginas para exibir
  const gerarPaginas = () => {
    const paginas = [];
    const maxPaginasVisiveis = 5;
    if (totalPaginas <= maxPaginasVisiveis) {
      for (let i = 1; i <= totalPaginas; i++) {
        paginas.push(i);
      }
    } else {
      if (paginaAtual <= 3) {
        for (let i = 1; i <= 4; i++) {
          paginas.push(i);
        }
        paginas.push('...');
        paginas.push(totalPaginas);
      } else if (paginaAtual >= totalPaginas - 2) {
        paginas.push(1);
        paginas.push('...');
        for (let i = totalPaginas - 3; i <= totalPaginas; i++) {
          paginas.push(i);
        }
      } else {
        paginas.push(1);
        paginas.push('...');
        for (let i = paginaAtual - 1; i <= paginaAtual + 1; i++) {
          paginas.push(i);
        }
        paginas.push('...');
        paginas.push(totalPaginas);
      }
    }
    return paginas;
  };

  const handleAbrirMenuAcoes = (pedidoId) => {
    setMenuAcoesAberto(pedidoId);
  };
  const handleFecharMenuAcoes = () => {
    setMenuAcoesAberto(null);
  };

  // Função para abrir modal de detalhes
  const handleVerDetalhes = (pedido) => {
    setPedidoDetalhes(pedido);
    setMenuAcoesAberto(null);
  };
  // Função para fechar modal
  const handleFecharModalDetalhes = () => {
    setPedidoDetalhes(null);
  };

  return (
    <div className="dashboard-root">
      <Sidebar menuAberto={menuAberto} setMenuAberto={setMenuAberto} />
      <div className="main-content">
        <Topbar
          setMenuAberto={setMenuAberto}
          titulo="Pedidos de Venda"
          botao={<button className="btn-novo">+ Novo Pedido</button>}
        />
        <div className="conteudo-dashboard pedidos-listagem">
          <div className="card-page-main">
            
            <div className="card-page-main-header">
              <div className="card-page-main-header-title">
                <h2>Pedidos de Venda</h2>
              </div>
              <button className="btn-novo-pedido">
                <Plus size={18} style={{ marginRight: 6 }} /> Novo Pedido
              </button>
            </div>
            {/* Filtros de Pesquisa - Collapse */}
            <div className="filtros-collapse">
              <div className="filtros-collapse-header" onClick={() => setFiltrosAbertos((v) => !v)}>
                <Filter size={15} style={{ marginRight: 8 }} />
                <span>Filtros de Pesquisa</span>
                <span className="filtros-collapse-arrow">
                  {filtrosAbertos ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                </span>
              </div>
              {filtrosAbertos && (
                <form className="filtros-form" onSubmit={handlePesquisar}>
                  <div className="filtros-grid">
                    <div className="filtro-item">
                      <label>Nome do Cliente</label>
                      <input
                        type="text"
                        name="nomeCliente"
                        placeholder="Digite o nome do cliente..."
                        value={filtros.nomeCliente}
                        onChange={handleChangeFiltro}
                      />
                    </div>
                    <div className="filtro-item">
                      <label>Número do Pedido</label>
                      <input
                        type="text"
                        name="numeroPedido"
                        placeholder="Digite o número do pedido..."
                        value={filtros.numeroPedido}
                        onChange={handleChangeFiltro}
                      />
                    </div>
                    <div className="filtro-item">
                      <label>CNPJ do Cliente</label>
                      <input
                        type="text"
                        name="cnpjCliente"
                        placeholder="Digite o CNPJ..."
                        value={filtros.cnpjCliente}
                        onChange={handleChangeFiltro}
                      />
                    </div>
                    <div className="filtro-item">
                      <label>Data Inicial</label>
                      <input
                        type="date"
                        name="dataInicial"
                        placeholder="dd/mm/aaaa"
                        value={filtros.dataInicial}
                        onChange={handleChangeFiltro}
                      />
                    </div>
                    <div className="filtro-item">
                      <label>Data Final</label>
                      <input
                        type="date"
                        name="dataFinal"
                        placeholder="dd/mm/aaaa"
                        value={filtros.dataFinal}
                        onChange={handleChangeFiltro}
                      />
                    </div>
                    <div className="filtro-item">
                      <label>Status</label>
                      <select
                        name="status"
                        value={filtros.status}
                        onChange={handleChangeFiltro}
                      >
                        <option value="">Todos os status</option>
                        <option value="pendente">Pendente</option>
                        <option value="processando">Processando</option>
                        <option value="enviado">Enviado</option>
                        <option value="cancelado">Cancelado</option>
                      </select>
                    </div>
                  </div>
                  <div className="filtros-botoes">
                    <button type="submit" className="btn-pesquisar">
                      <Search size={16} style={{ marginRight: 6 }} /> Pesquisar
                    </button>
                    <button type="button" className="btn-limpar" onClick={handleLimpar}>
                      Limpar Filtros
                    </button>
                  </div>
                </form>
              )}
            </div>
            <div className="cards-list">
              {carregando ? (
                <div style={{ padding: 32, textAlign: 'center', color: '#888' }}>Carregando pedidos...</div>
              ) : pedidos.length === 0 ? (
                <div style={{ padding: 32, textAlign: 'center', color: '#888' }}>Nenhum pedido encontrado.</div>
              ) : (
                pedidos.map(pedido => (
                  
                    
                  <div className="card-list" key={pedido.id}>
                    <div className="card-list-header">
                      <span className="pedido-id">{pedido.numero_pedido}</span>
                      <span
                        className="pedido-status"
                        style={{
                          background: statusColors[pedido.status]?.bg,
                          color: statusColors[pedido.status]?.color
                        }}
                      >
                        {pedido.status.charAt(0).toUpperCase() + pedido.status.slice(1)}
                      </span>
                      <div className="card-list-acoes">
                        <button
                          className="card-list-acoes-btn"
                          onClick={() => menuAcoesAberto === pedido.id ? handleFecharMenuAcoes() : handleAbrirMenuAcoes(pedido.id)}
                          tabIndex={0}
                          aria-label="Ações do pedido"
                        >
                          <MoreVertical size={20} />
                        </button>
                        {menuAcoesAberto === pedido.id && (
                          <div className="card-list-menu-popover" onMouseLeave={handleFecharMenuAcoes}>
                            <button className="card-list-menu-item" onClick={() => handleVerDetalhes(pedido)}>
                              <Eye size={16} style={{ marginRight: 8 }} /> Ver Detalhes
                            </button>
                            <button className="card-list-menu-item" onClick={() => { handleFecharMenuAcoes(); /* ação editar */ }}>
                              <Edit size={16} style={{ marginRight: 8 }} /> Editar
                            </button>
                            <button className="card-list-menu-item card-list-menu-excluir" onClick={() => { handleFecharMenuAcoes(); /* ação excluir */ }}>
                              <Trash2 size={16} style={{ marginRight: 8 }} /> Excluir
                            </button>
                            
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="card-list-body">
                      <div className="pedido-info">
                        <span className="pedido-cliente">
                          <User size={16} style={{ marginRight: 4 }} />
                          {pedido.cliente?.nome}
                        </span>
                      </div>
                      <div className="pedido-valor">
                        <span className="pedido-total">R$ {Number(pedido.valor_total).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                      </div>
                      <div className="pedido-data">
                        <Calendar size={16} style={{ marginRight: 4 }} />
                        {formatDate(pedido.data_pedido, pedido.hora_pedido)}
                      </div>
                      <div className="pedido-itens">
                        {pedido.itens?.length || 0} {pedido.itens?.length === 1 ? 'item' : 'itens'}
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
            
            {/* Componente de Paginação */}
            {totalPaginas > 1 && (
              <div className="paginacao-container">
                <div className="paginacao-info">
                  <span>
                    Mostrando {(paginaAtual - 1) * 10 + 1} a {Math.min(paginaAtual * 10, totalItens)} de {totalItens} pedidos
                  </span>
                </div>
                <div className="paginacao-controles">
                  <button
                    className="paginacao-btn"
                    onClick={() => mudarPagina(paginaAtual - 1)}
                    disabled={paginaAtual === 1}
                  >
                    <ChevronLeft size={16} />
                    Anterior
                  </button>
                  
                  <div className="paginacao-numeros">
                    {gerarPaginas().map((pagina, index) => (
                      <button
                        key={index}
                        className={`paginacao-numero ${pagina === paginaAtual ? 'ativo' : ''} ${pagina === '...' ? 'separador' : ''}`}
                        onClick={() => typeof pagina === 'number' && mudarPagina(pagina)}
                        disabled={pagina === '...'}
                      >
                        {pagina}
                      </button>
                    ))}
                  </div>
                  
                  <button
                    className="paginacao-btn"
                    onClick={() => mudarPagina(paginaAtual + 1)}
                    disabled={paginaAtual === totalPaginas}
                  >
                    Próxima
                    <ChevronRight size={16} />
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Modal de Detalhes do Pedido */}
      {pedidoDetalhes && (
        <div className="modal-detalhes-overlay">
          <div className="modal-detalhes">
            <button className="modal-detalhes-fechar" onClick={handleFecharModalDetalhes} aria-label="Fechar">
              <X size={22} />
            </button>
            <h2 className="modal-detalhes-titulo">
              Detalhes do Pedido <span className="modal-detalhes-numero">#{pedidoDetalhes.numero_pedido}</span>
            </h2>
            <div className="modal-detalhes-row">
              <div className="modal-detalhes-col">
                <div className="modal-detalhes-label">Informações do Cliente</div>
                <div><b>Nome:</b> {pedidoDetalhes.cliente?.nome}</div>
                <div><b>Email:</b> {pedidoDetalhes.cliente?.email}</div>
                <div><b>CNPJ:</b> {pedidoDetalhes.cliente?.documento}</div>
              </div>
              <div className="modal-detalhes-col" style={{ minWidth: 180 }}>
                <div className="modal-detalhes-label">Status do Pedido</div>
                <span className="modal-detalhes-status" style={{ background: statusColors[pedidoDetalhes.status]?.bg, color: statusColors[pedidoDetalhes.status]?.color }}>
                  {pedidoDetalhes.status.charAt(0).toUpperCase() + pedidoDetalhes.status.slice(1)}
                </span>
              </div>
            </div>
            <div className="modal-detalhes-label" style={{ marginTop: 18 }}>Itens do Pedido</div>
            <div className="modal-detalhes-tabela-wrapper">
              <table className="modal-detalhes-tabela">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Qtd</th>
                    <th>Preço Unit.</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {pedidoDetalhes.itens?.map((item, idx) => (
                    <tr key={item.id || idx}>
                      <td>{item.produto?.nome}</td>
                      <td>{item.quantidade}</td>
                      <td>R$ {Number(item.preco_unitario).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                      <td><b>R$ {Number(item.subtotal).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</b></td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan="3" style={{ textAlign: 'right', fontWeight: 500 }}>Subtotal:</td>
                    <td><b>R$ {Number(pedidoDetalhes.valor_total).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</b></td>
                  </tr>
                  <tr>
                    <td colSpan="3" style={{ textAlign: 'right', fontWeight: 700, fontSize: 16 }}>Total:</td>
                    <td style={{ color: '#16a34a', fontWeight: 700, fontSize: 16 }}>R$ {Number(pedidoDetalhes.valor_total).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="modal-detalhes-row" style={{ marginTop: 18 }}>
              <div className="modal-detalhes-col">
                <div className="modal-detalhes-label">Data:</div>
                <div>{formatDate(pedidoDetalhes.data_pedido, pedidoDetalhes.hora_pedido)}</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PedidosList; 